import App from 'app/app.js';
import 'app/store/ContentStore.js';
import 'app/store/ProductCatalogStore.js';

function LtPromoZoneCarouselController($scope, $window, ContentStore, ProductCatalogStore) {
  this.promoItems = [];
  this.pageIndex = 0;
  $scope.hasSlides = true;

  this.init = function () {
    if (!!$scope.promoZoneCodes) {
      R.forEach(
        function (promoZoneCode) {
          var listOfPromos = this.filterPromotions(ContentStore.getZoneDetails(promoZoneCode));
          if (!!listOfPromos && listOfPromos.length > 0) {
            this.promoItems.push(listOfPromos[0].contentItem);
          }
        }.bind(this)
      )($scope.promoZoneCodes);
    }

    if (this.promoItems.length <= 0) {
      $scope.hasSlides = false;
    }
  };

  this.filterPromotions = function (promoContent) {
    var listOfPromos = [];
    if (!!promoContent) {
      listOfPromos = promoContent.filter(function (zoneDetail) {
        return R.any(R.propEq('promotionCode', zoneDetail.code))(
          ProductCatalogStore.getProductCatalog()?.promotions ?? []
        );
      });
    }
    return listOfPromos;
  };

  this.prevPage = function () {
    if (this.pageIndex > 0) {
      this.pageIndex--;
    }
  };

  this.nextPage = function () {
    if (this.pageIndex < this.promoItems.length - 1) {
      this.pageIndex++;
    }
  };

  this.hasMultiplePromoItems = function () {
    if (this.promoItems.length > 1) {
      return true;
    }
  };
}

App.controller('LtPromoZoneCarouselCtrl', [
  '$scope',
  '$window',
  'ContentStore',
  'ProductCatalogStore',
  LtPromoZoneCarouselController
]);
